import {GenericRequest, getUrlEndpointPrivate} from '@cuatroochenta/co-admin-react-library';
import {
    BulletinListExportExcelRequest
} from '../request/BulletinListExportExcelRequest';

export default class TaskBulletinListExportExcel extends GenericRequest {

    private readonly data;

    public constructor(data: BulletinListExportExcelRequest) {
        super('POST' as any, getUrlEndpointPrivate('bulletins/export'));
        this.data = data;
    }

    public overrideRequest() {
        return {criteria: this.data};
    }
}